import Flex from 'components/common/Flex';
import React, { useState } from 'react';
import { Button, Card, Form } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import CompletionDocumentation from './project-completion-component/CompletionDocumentation';
import CompletionInfo from './project-completion-component/CompletionInfo';

const ProjectCompletion = () => {
  const navigate = useNavigate();
  const [validated, setValidated] = useState(false);

  const handleSubmit = event => {
    const form = event.currentTarget;
    if (form.checkValidity() === false) {
      event.preventDefault();
      event.stopPropagation();
    }

    setValidated(true);
  };
  return (
    <Form noValidate validated={validated} onSubmit={handleSubmit}>
      <CompletionInfo />
      <CompletionDocumentation />
      <Card>
        <Card.Body>
          <Flex
            justifyContent="between"
            alignItems="center"
            className="flex-column flex-md-row"
          >
            <p className="mb-0 fs-2 mb-2 mb-md-0 fw-medium">Progress Report</p>
            <Button className="w-215px" onClick={() => navigate('report')}>
              Submit
            </Button>
          </Flex>
        </Card.Body>
      </Card>
    </Form>
  );
};

export default ProjectCompletion;
